import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AtokuEquipment } from '../../../models/atoku-equipment.model';

export interface EditDialogData extends AtokuEquipment {
    type: 'equipment' | 'storage';
}

@Component({
    selector: 'app-edit-equipment-dialog',
    templateUrl: './edit-equipment-dialog.component.html',
    styleUrls: ['./edit-equipment-dialog.component.scss']
})
export class EditEquipmentDialogComponent implements OnInit {
    form: FormGroup;
    title: string;

    constructor(
        public dialogRef: MatDialogRef<EditEquipmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EditDialogData,
        private fb: FormBuilder
    ) {
        this.title = data.type === 'equipment' ? 'Edit Equipment' : 'Edit Storage Unit';
        this.form = this.fb.group({
            id: [data.id],
            equipmentName: [data.equipmentName, Validators.required],
            totalAmount: [data.totalAmount, [Validators.required, Validators.min(0)]],
            bookedLast30Days: [{ value: data.bookedLast30Days, disabled: true }]
        });
    }

    ngOnInit(): void {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.getRawValue());
        }
    }
}
